const KNOWN_KEYS = new Set([
  'LicensePlate', 'VehicleType', 'VehicleColor', 'Direction', 'Location',
  'Brand', 'Model', 'Year', 'Gender', 'Hat', 'Age', 'TrousersColor',
  'JacketColor', 'ShirtColor', 'Height', 'Weight', 'HairColor', 'SkinColor',
  'Glasses', 'Mask', 'Beard', 'Emotion', 'Pose', 'Activity', 'Accessories',
])

const KEY_LABELS: Record<string, string> = {
  Confidence: 'Confiança', Speed: 'Velocidade', Temperature: 'Temperatura',
  Humidity: 'Umidade', DetectionScore: 'Pontuação de Detecção',
  ProcessingTime: 'Tempo de Processamento', Algorithm: 'Algoritmo',
  Version: 'Versão', CameraFPS: 'FPS da Câmera', Resolution: 'Resolução',
  Timestamp: 'Data/Hora', EventId: 'ID do Evento', SessionId: 'ID da Sessão',
  UserId: 'ID do Usuário', ClientId: 'ID do Cliente', Zone: 'Zona',
  Area: 'Área', Region: 'Região', Country: 'País', State: 'Estado',
  City: 'Cidade', Weather: 'Clima', LightCondition: 'Condição de Iluminação',
  Quality: 'Qualidade', Size: 'Tamanho', Distance: 'Distância',
  Angle: 'Ângulo', Brightness: 'Brilho', Contrast: 'Contraste',
  Saturation: 'Saturação', Sharpness: 'Nitidez',
}

interface TechnicalMetadataCardProps {
  metadata: Record<string, string>
}

const TechnicalMetadataCard = ({ metadata }: TechnicalMetadataCardProps) => {
  const entries = Object.entries(metadata).filter(([key]) => !KNOWN_KEYS.has(key))
  if (entries.length === 0) return null

  return (
    <div className='detail-card'>
      <h4>
        <i className='pi pi-cog mr-2' />
        Metadados Técnicos
      </h4>
      <div className='detail-grid'>
        {entries.map(([key, value]) => (
          <div key={key} className='detail-item'>
            <span className='detail-label'>
              <i className='pi pi-tag mr-1' />
              {KEY_LABELS[key] || key}:
            </span>
            <span className='detail-value'>{value}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TechnicalMetadataCard
